import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates';
import { FaPen, FaTrash } from 'react-icons/fa'
import axios from 'axios';
import { Url } from '../Url';
import FooterVenta from '../footerVenta';
import SearchAutoComplete from '../searchAutoComplete';


const FEditPresupuesto = () => {
    const [cantidad, setCantidad] = useState('')
    const [producto, setProducto] = useState({})
    const [precioUnitario, setPrecioUnitario] = useState('')
    const { ventaSelected, productos, setProductos, codigo, setCodigo, venta, setVenta, setProductoSelected, cliente, setCliente,
        setViewOpen, modify, setFormView, precio, searchTerm, setSearchTerm, presupuesto, setPresupuesto, setEditarList, porcentajeDesc, setPorcentajeDesc } = useContext(ContextStates)

    const inputRef = useRef(null);
    const cantRef = useRef(null);

    useEffect(() => {
        setPresupuesto(true)
        setEditarList(true)
        if (ventaSelected.productos) {
            setVenta(ventaSelected.productos)
        }
        if (ventaSelected.clienteObj) {
            setCliente(ventaSelected.clienteObj)
        }
        if (ventaSelected.descuentos) {
            ventaSelected.descuentos.forEach(element => {
                if (element.tipo === '2') {
                    setPorcentajeDesc(element.valor)
                }
            });
        }
    }, [])

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                //console.log(results.data.results)
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify])

    useEffect(() => {
        const addProducto = async () => {
            if (typeof producto !== 'undefined') {
                if (producto.codigo) {
                    const auxVenta = JSON.stringify(venta)
                    const formData = new FormData()
                    formData.append('venta', auxVenta);
                    formData.append('producto', JSON.stringify(producto));
                    //formData.append('cantidad', producto.cantidad);
                    try {
                        const response = await axios({
                            url: Url + 'api/addProducto.php',
                            'Content-Type': 'application/json',
                            method: 'POST',
                            data: formData,
                            dataType: 'JSON',
                        })
                        console.log(response)
                        setVenta(response.data.results);
                        setSearchTerm('')
                        setProducto({})
                        setCantidad('')
                        setPrecioUnitario('')
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        }
        addProducto()
    }, [producto])


    const handleSubmit = async (event) => {
        //console.log(valores.codigo)
        event.preventDefault();
        if (cantidad !== '') {
            const formData = new FormData()
            formData.append('codigo', codigo);
            formData.append('cantidad', cantidad);

            let aux = await productos.find(element => element.codigo === codigo);
            if (typeof aux !== 'undefined') {
                aux.cantidad = cantidad;
                setProducto(aux)
            }
            setCodigo('')

        }
        else {
            cantRef.current.focus()
        }
    }

    useEffect(() => {
        if (codigo != '') {
            inputRef.current.focus()
        }
    }, [codigo])

    useEffect(() => {
        const checkDatos = () => {
            productos.forEach(element => {
                if (element.codigo === codigo && codigo!=='') {
                    setSearchTerm(element.descripcion)
                    if (!precio) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            setPrecioUnitario(element.preciopromocion)
                        }
                        else {
                            setPrecioUnitario(element.precio)
                        }
                    }
                    else {
                        setPrecioUnitario(element.preciopormayor)
                    }
                    if (cantidad === '') {
                        if (codigo === '') {
                            inputRef.current.focus()
                        }
                        else {
                            cantRef.current.focus()
                        }
                    }
                }
            });
        }
        checkDatos()
    }, [codigo])

    useEffect(() => {
        const handleSetPrecio = () => {
            if (codigo != '') {
                productos.forEach(element => {
                    if (element.codigo === codigo) {
                        if (element.idunidad !== '1') {
                            let aux = 0;
                            if (!precio) {
                                if (element.tipopromo === '1' || element.tipopromo === '2') {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.preciopromocion);
                                }
                                else {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.precio);
                                }
                            }
                            else {
                                aux = parseFloat(precioUnitario) / parseFloat(element.preciopormayor);
                            }
                            //aux = aux.toFixed(5)
                            //setCantidad(aux)
                        }
                    }
                });
            }
        }
        handleSetPrecio()
    }, [precioUnitario])

    const submitCantidad = (event) => {
        event.preventDefault();
        if (cantidad !== '' && codigo !== '') {
            handleSubmit(event)
            inputRef.current.focus()
        }
    }

    const handleAdd = (e) => {
        handleSubmit(e);
        inputRef.current.focus()
    }

    const handleDelete = (item) => {
        let rData = [...venta]
        rData.forEach(element => {
            if (element.id === item.id) {
                element.cantidad = 0
            }
        });
        setVenta(rData)
    }

    const handleSet = (item) => {
        setProductoSelected(item)
        setFormView(1)
        setViewOpen(true)
    }

    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio);
    }

    return (
        <div className='flex flex-col min-h-screen gap-2'>
            <div className="transition-all w-full mt-3 flex">
                <div className={`w-full md:w-10/12 mx-auto mt-1 p-1 md:p-3 rounded-lg md:flex ${presupuesto ? 'bg-red-200' : !precio ? 'bg-indigo-200' : 'bg-orange-200'} `}>
                    <form
                        className="w-full md:w-1/4"
                        onSubmit={handleSubmit}
                    >
                        <div className="sm:items-start px-2 lg:px-3">
                            <label htmlFor="codigo" className="block text-gray-600 uppercase font-bold">Código</label>
                            <input
                                type="text"
                                className="py-2 px-2 lg:px-3 w-full rounded"
                                id="codigo"
                                ref={inputRef}
                                placeholder="Código de producto"
                                value={codigo}
                                onChange={(e) => setCodigo(e.target.value)}
                                autoFocus
                            />
                        </div>
                    </form>
                    <div className="w-full md:w-1/2 sm:items-start px-2 lg:px-3">
                        <SearchAutoComplete
                            items={productos}
                        />
                    </div>
                    <div className="w-1/10 sm:items-start px-2 lg:px-3">
                        <label htmlFor="punitario" className="block text-gray-600 uppercase font-bold">Precio unit.</label>
                        <input
                            type="text"
                            className="py-2 px-2 lg:px-3 w-full rounded"
                            id="punitario"
                            value={precioUnitario}
                            onChange={(e) => setPrecioUnitario(e.target.value)}
                        />
                    </div>
                    <div className="w-1/10 sm:items-start px-2 lg:px-3">
                        <form onSubmit={submitCantidad}>
                            <label htmlFor="cantidad" className="block text-gray-600 uppercase font-bold">Cantidad</label>
                            <input
                                type="number"
                                className="py-2 px-3 w-full rounded"
                                id="cantidad"
                                ref={cantRef}
                                placeholder="Cantidad"
                                value={cantidad}
                                onChange={(e) => setCantidad(e.target.value)}
                            />
                        </form>
                    </div>
                    <div className="w-1/10 sm:items-start px-2 lg:px-3 pt-4">
                        <input
                            type="button"
                            className="w-full shadow-md p-3 bg-blue-600 text-gray-100 hover:bg-blue-500 hover:cursor-pointer transition-all uppercase font-semibold rounded mt-1"
                            value="Agregar"
                            onClick={(e) => handleAdd(e)}
                        />
                    </div>
                </div>
            </div>
            <div className="w-10/12 mx-auto mt-3 mb-20">
                {typeof venta !== 'undefined' && venta.length > 0 && (
                    <table className='table-auto w-full border border-collapse border-gray-300'>
                        <thead>
                            <tr className='border border-collapse border-gray-300 bg-blue-100'>
                                <th className='border border-collapse border-gray-300'>Cantidad</th>
                                <th className='border border-collapse border-gray-300'>Código</th>
                                <th className='border border-collapse border-gray-300'>Descripción</th>
                                <th className='border border-collapse border-gray-300'>Precio</th>
                                <th className='border border-collapse border-gray-300'>Subtotal</th>
                                <th className='border border-collapse border-gray-300'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {typeof venta !== 'undefined' && venta.map((item, index) => (
                                item.cantidad > 0 && (
                                    <tr
                                        key={index}
                                        className={`${index % 2 === 0 ? 'bg-white hover:bg-slate-200' : 'bg-slate-100 hover:bg-slate-200'} ' hover:cursor-pointer border-b border-gray-200 ')`}
                                    >
                                        <td className='border border-collapse border-gray-300 px-3 text-center'>{item.cantidad}</td>
                                        <td className='border border-collapse border-gray-300 px-3 text-center'>{item.codigo}</td>
                                        <td className='border border-collapse border-gray-300 px-3'>{item.descripcion}</td>
                                        <td className={`border border-collapse border-gray-300 px-3 text-right`}>{parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td className={`border border-collapse border-gray-300 px-3 text-right`}>{(parseFloat(item.precio) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td className='border border-collapse border-gray-300 px-3 text-center'>
                                            <button
                                                className='bg-gray-400 p-3 rounded-md text-white ml-3'
                                                onClick={() => handleSet(item)}
                                            >
                                                <FaPen />
                                            </button>
                                            <button
                                                className='bg-red-400 p-3 rounded-md text-white ml-3'
                                                onClick={() => handleDelete(item)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <FooterVenta />
        </div>
    )
}

export default FEditPresupuesto